

export const PERMISSIONS = Object.freeze({

  // ─── STUDENT MANAGEMENT ────────────────────────────────────────────────────
  STUDENT_VIEW_ALL:   "STUDENT_VIEW_ALL",    // View every student school-wide
  STUDENT_VIEW_CLASS: "STUDENT_VIEW_CLASS",  // View students in own assigned class only
  STUDENT_ADD:        "STUDENT_ADD",         // Enrol a new student
  STUDENT_EDIT:       "STUDENT_EDIT",        // Edit student profile / details
  STUDENT_DELETE:     "STUDENT_DELETE",      // Remove a student record
  STUDENT_PROMOTE:    "STUDENT_PROMOTE",     // Year-end promotion to next class

  // ─── ACADEMIC ──────────────────────────────────────────────────────────────
  ACADEMIC_VIEW_GRADES:     "ACADEMIC_VIEW_GRADES",     // Read grades / mark-sheets
  ACADEMIC_ENTER_GRADES:    "ACADEMIC_ENTER_GRADES",    // Input / update student marks
  ACADEMIC_VIEW_ATTENDANCE: "ACADEMIC_VIEW_ATTENDANCE", // Read attendance records
  ACADEMIC_MARK_ATTENDANCE: "ACADEMIC_MARK_ATTENDANCE", // Submit daily attendance
  ACADEMIC_CREATE_EXAM:     "ACADEMIC_CREATE_EXAM",     // Create / schedule exams
  ACADEMIC_VIEW_REPORTS:    "ACADEMIC_VIEW_REPORTS",    // View performance reports

  // ─── FEE MANAGEMENT — OPERATIONS ───────────────────────────────────────────
  FEE_VIEW_ALL:         "FEE_VIEW_ALL",         // Read all fee records school-wide
  FEE_COLLECT:          "FEE_COLLECT",          // Accept / record fee payments
  FEE_REFUND:           "FEE_REFUND",           // Process refunds
  FEE_GENERATE_RECEIPT: "FEE_GENERATE_RECEIPT", // Print / download receipts
  FEE_VIEW_REPORTS:     "FEE_VIEW_REPORTS",     // View collection reports & analytics

  // ─── FEE MANAGEMENT — STRUCTURE ────────────────────────────────────────────
  // Hierarchy: MANAGE is a superset of CREATE + EDIT + ASSIGN.
  // Grant MANAGE to admins; grant granular codes to fee managers with limited scope.
  FEE_STRUCTURE_MANAGE: "FEE_STRUCTURE_MANAGE", // Full control: create, edit, delete, assign
  FEE_STRUCTURE_CREATE: "FEE_STRUCTURE_CREATE", // Create new fee structures
  FEE_STRUCTURE_EDIT:   "FEE_STRUCTURE_EDIT",   // Modify fee amounts and rules
  FEE_STRUCTURE_ASSIGN: "FEE_STRUCTURE_ASSIGN", // Assign fee structures to classes / students

  // ─── STAFF MANAGEMENT ──────────────────────────────────────────────────────
  STAFF_VIEW_ALL:       "STAFF_VIEW_ALL",       // View all staff records
  STAFF_ADD:            "STAFF_ADD",            // Onboard new staff
  STAFF_EDIT:           "STAFF_EDIT",           // Edit staff profiles
  STAFF_DELETE:         "STAFF_DELETE",         // Remove a staff record
  STAFF_ASSIGN_CLASSES: "STAFF_ASSIGN_CLASSES", // Assign / change class assignments
  STAFF_PAYROLL_MANAGEMENT : "STAFF_PAYROLL_MANAGEMENT", // Manage salary, deductions, bonuses, etc.

  // ─── COMMUNICATION ─────────────────────────────────────────────────────────
  COMM_SEND_NOTICE:   "COMM_SEND_NOTICE",   // Broadcast notices to students / parents
  COMM_SEND_SMS:      "COMM_SEND_SMS",      // Send SMS notifications
  COMM_VIEW_MESSAGES: "COMM_VIEW_MESSAGES", // Read all communication threads

  // ─── LIBRARY ───────────────────────────────────────────────────────────────
  LIBRARY_MANAGE_BOOKS: "LIBRARY_MANAGE_BOOKS", // Add, edit, remove book catalogue
  LIBRARY_ISSUE_BOOKS:  "LIBRARY_ISSUE_BOOKS",  // Issue books to students
  LIBRARY_VIEW_RECORDS: "LIBRARY_VIEW_RECORDS", // View issue / return history

  // ─── TRANSPORT ─────────────────────────────────────────────────────────────
  TRANSPORT_MANAGE_ROUTES:   "TRANSPORT_MANAGE_ROUTES",   // CRUD on bus routes
  TRANSPORT_ASSIGN_STUDENTS: "TRANSPORT_ASSIGN_STUDENTS", // Assign students to routes
  TRANSPORT_VIEW_REPORTS:    "TRANSPORT_VIEW_REPORTS",    // Utilisation & trip reports

  // ─── SYSTEM ADMIN ──────────────────────────────────────────────────────────
  SYSTEM_USER_MANAGEMENT:  "SYSTEM_USER_MANAGEMENT",  // Manage portal user accounts
  SYSTEM_USER_CHANGE_PASSWORD: "SYSTEM_USER_CHANGE_PASSWORD", // Reset user passwords
  SYSTEM_PERMISSION_GRANT: "SYSTEM_PERMISSION_GRANT", // Grant / revoke permissions
  SYSTEM_BACKUP:           "SYSTEM_BACKUP",           // Trigger and download backups
  SYSTEM_CONFIG:           "SYSTEM_CONFIG",           // School-wide settings
  SYSTEM_VIEW_LOGS:        "SYSTEM_VIEW_LOGS",        // Audit trail / activity log

  // ─── PLATFORM BILLING ─────────────────────────────────────────────────────
  BILLING_VIEW:   "BILLING_VIEW",   // View platform subscriptions, invoices, payments, and audit
  BILLING_MANAGE: "BILLING_MANAGE", // Create and manage subscriptions, invoices, and manual payments
  BILLING_REFUND: "BILLING_REFUND", // Refund eligible platform payments
});

/**
 * SUPER_ADMIN_BYPASS_ROLES
 * Users holding any of these roles automatically pass every permission check.
 * Add new privileged roles here — never hard-code them inside components.
 */
export const SUPER_ADMIN_BYPASS_ROLES = Object.freeze([
  "ROLE_PRINCIPAL",
  "ROLE_SCHOOL_ADMIN",
  "ROLE_ADMIN",
]);